const config = {
  // is local development
  isLocal: process.env.NODE_ENV === 'development',
  node_env: process.env.NODE_ENV,
  app_env: process.env.REACT_APP_ENV,
  // is local development or staging
  isDev: process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'staging',
  isStaging: process.env.REACT_APP_ENV === 'staging',
  isUAT: process.env.REACT_APP_ENV === 'uat',
  isProd: process.env.REACT_APP_ENV === 'production',
  sentry: {
    dsn: process.env.REACT_APP_SENTRY_DSN,
    release: process.env.REACT_APP_SENTRY_RELEASE,
  },
  legal: {
    company_name: 'Firstdate Inc.',
    privacy_policy: '/legal/Privacy_Policy.pdf',
    terms_conditions: '/legal/Terms_and_Conditions.pdf',
    dater_terms: '/legal/Customer_Terms_of_Service.pdf',
    host_terms: '/legal/Partner_Terms_of_Service.pdf',
  },
  company_name: 'teleport',
  backend_app: process.env.REACT_APP_NODE_SERVER_URL,
  socket_server: process.env.REACT_APP_NODE_SERVER_SOCKET,
  main_domain: process.env.REACT_APP_MAIN_DOMAIN,
  stripe: {
    public_key: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
    connect_key: process.env.REACT_APP_STRIPE_CONNECT,
  },
  ios: {
    appLink: process.env.REACT_APP_IOS_APP_LINK,
    appId: process.env.REACT_APP_IOS_APP_ID,
    appClipBundleId: process.env.REACT_APP_APP_CLIP_BUNDLE_ID,
  },
  domain_links: {
    landing: 'https://teleport.co',
    about: 'https://web3.teleport.co',
    press_email: 'mailto:press@teleport.us',
    host_landing: 'https://teleportdates.typeform.com/to/vScoUXzz',
    partners_email: 'mailto:partnerships@teleport.us',
    careers: 'https://teleport.applytojobs.ca',
    support_email: 'support@teleport.co',
    bachelorette_consent: 'https://drive.google.com/file/d/1ZbVvXY7RbCK163oo63L4tbCoe8pkulgf/view',
    bachelorette_application: 'https://www.videoask.com/fb3n29oyo',
    web3: 'https://web3.teleport.co',
  },
  social: {
    facebook: {
      app_id: process.env.REACT_APP_FACEBOOK_APP_ID,
      messenger_url: 'https://m.me/teleportdates',
      page_url: 'https://www.facebook.com/teleportdates',
    },
    instagram: {
      page_url: 'https://www.instagram.com/teleportnyc',
    },
    twitter: {
      page_url: 'https://twitter.com/intent/user?screen_name=teleportsc',
    },
    linkedin: {
      page_url: 'https://www.linkedin.com/company/teleportdates',
    },
    tiktok: {
      page_url: 'https://www.tiktok.com/@teleportdates?lang=en',
    },
    discord: {
      page_url: 'https://discord.com/invite/69u4e74jfJ',
    },
  },
  aws: {
    region: process.env.REACT_APP_AWS_REGION,
    pool_id: process.env.REACT_APP_AWS_POOL_ID,
  },
  help_page_url: 'https://help.teleport.co/',
  publicUrl: process.env.PUBLIC_URL,
  logrocket: {
    app_id: process.env.REACT_APP_LOGROCKET_ID,
  },
  supportEmail: 'support@teleport.us',
  streamApiKey: process.env.REACT_APP_STREAM_API_KEY,
  intercom: {
    app_id: process.env.REACT_APP_INTERCOM_APP_ID,
  },
  media: {
    landing: {
      learnMore: {
        desktop: 'https://assets.teleport.co/media/Landscape_Teleport-co_LoRes.mp4',
        mobile: 'https://assets.teleport.co/media/Portrait_Teleport-co_LoRes.mp4',
      },
      promo: {
        desktop: 'https://assets.teleport.co/media/landing-promo-landscape.mp4',
        mobile: 'https://assets.teleport.co/media/landing-promo-potrait.mp4',
      },
    },
    walletModal: {
      videoBanner: 'https://teleport-assets.s3.amazonaws.com/web3/media/videos/heart-loop.mp4',
    },
  },
  chromeDownloadLink: 'https://www.google.com/chrome',
  cloudinary: {
    cloudName: process.env.REACT_APP_CLOUDINARY_CLOUD_NAME,
  },
  agora: {
    appId: process.env.REACT_APP_AGORA_APP_ID,
  },
  waitlist: true,
}

export default config
